import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

import { ListButton } from 'components';
import Popover from 'components/popover';


@withTranslation()
export default class ArchivedReleaseModal extends React.Component {
	static propTypes = {
		release: PropTypes.object.isRequired,
		isOpen: PropTypes.bool.isRequired,
		hideTrigger: PropTypes.bool.isRequired,
		isDownloadAllowed: PropTypes.bool.isRequired,

		t: PropTypes.func.isRequired,
		onToggle: PropTypes.func.isRequired,
		handleRestoreClick: PropTypes.func.isRequired,
		handleDownloadClick: PropTypes.func.isRequired
	}

	handleDownloadClick = () => {
		const { release, onToggle, handleDownloadClick } = this.props;

		onToggle();
		handleDownloadClick(release);
	}

	render() {
		const {
			t,
			release,
			isOpen,
			hideTrigger,
			onToggle,
			isDownloadAllowed,
			handleRestoreClick
		} = this.props;

		return (
			<Popover
				isOpen={isOpen}
				hideTrigger={hideTrigger}
				onToggle={onToggle}>
				<div
					className="bg-white rounded text-black overflow-y-auto max-h-64 scrollbar w-40">
					{
						isDownloadAllowed &&
						<ListButton
							name={t('general.download')}
							onClick={this.handleDownloadClick} />
					}
					<ListButton
						name={t('collections.restore')}
						onClick={() => handleRestoreClick(release)} />
					<ListButton
						className="px-0 py-0"
						name={
							<Link
								className="w-full"
								to={'/releases/releaseInfo/' + release.releaseid}>
								<div className="px-4 py-1">
									{t('general.release-information')}
								</div>
							</Link>
						} />
				</div>
			</Popover>
		);
	}
}
